<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import * as echarts from 'echarts';
import { voucherDataStatistics, voucherDataContrast, pendingData, getRegisterDeadline } from '../../../api/home.js';

export default {
	data() {
		return {
			box_up_height: '',
			box_up_left_below_height: '',
			box_up_right_height: '',
			box_up_right_below_height: '',
			// box_height: '',
			box_below_height: '',
			userInfo: JSON.parse(localStorage.getItem('currentLoginUser')) || {},
			text: '早上好',
			penData: {
				total: 0
			},
			getRegisterData: {},
			isdq: false,
			value: ''
		};
	},
	mounted() {
		this.initCharts();
		this.heightadaptivity();
		this.getTimState();
		this.pendingData();
		this.getRegisterDeadline();
		window.addEventListener('resize', () => {
			this.heightadaptivity();
		});
	},
	created() {},
	methods: {
		ISee() {
			this.isdq = false;
		},
		getRegisterDeadline() {
			getRegisterDeadline().then(res => {
				if (res.data.code == '200') {
					this.getRegisterData = res.data.data;
					if (res.data.data.state == '0') {
						this.isdq = true;
					}
				}
			});
		},
		pendingData() {
			pendingData().then(res => {
				if (res.data.code == '200') {
					this.penData = res.data.data;
				}
			});
		},
		getTimState() {
			// 获取当前时间
			let timeNow = new Date();
			// 获取当前小时
			let hours = timeNow.getHours();
			// 判断当前时间段
			if (hours >= 0 && hours <= 7) {
				this.text = `早上好`;
			} else if (hours > 7 && hours <= 12) {
				this.text = `上午好`;
			} else if (hours > 12 && hours <= 18) {
				this.text = `下午好`;
			} else if (hours > 18 && hours <= 24) {
				this.text = `晚上好`;
			}
		},
		heightadaptivity() {
			let height = document.body.clientHeight - 172 - 16 - 16 - 136;
			this.box_below_height = height / 2 + 'px';
			this.box_up_left_below_height = height / 2 + 'px';
			this.box_up_height = document.body.clientHeight - 136 + 'px';
			this.box_up_right_height = document.body.clientHeight - 310 - 16 - 136 + 'px';
			this.box_up_right_below_height = document.body.clientHeight - 310 - 16 - 104 - 136 + 'px';
			// this.box_height = (height+16+21+16+172)+ 'px';
			// if (document.body.clientHeight > 820) {
			// 	this.box_up_height = 468 + (document.body.clientHeight - 820) + 'px';
			// 	this.box_up_right_height = 468 + (document.body.clientHeight - 820) + 'px';
			// 	this.box_up_left_below_height = 280 + (document.body.clientHeight - 820) + 'px';
			// 	this.box_up_right_below_height = 350 + (document.body.clientHeight - 820) + 'px';
			// 	this.box_height = 836 + (document.body.clientHeight - 820) + 'px';
			// }
		},
		initCharts() {
			this.$nextTick(() => {
				let myChart = echarts.init(document.getElementById('number'));
				let option = {
					grid: {
						top: '31',
						left: '19',
						right: '26',
						bottom: '25',
						containLabel: true
					},
					xAxis: [
						{
							axisLine: {
								onZero: false,
								lineStyle: {
									color: '#BFBFBF'
								}
							},
							type: 'category',
							data: ['2018年', '2019年', '2020年', '2021年', '2022年', '2023年'],
							axisTick: {
								alignWithLabel: true
							}
						}
					],
					yAxis: [
						{
							type: 'value',
							axisLine: {
								lineStyle: {
									color: '#BFBFBF'
								}
							}
						}
					],
					series: [
						{
							name: 'Direct',
							type: 'bar',
							barWidth: '15%',
							data: [0, 0, 0, 0, 0, 0, 0],
							itemStyle: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: '#0065B1' }, { offset: 1, color: '#FFFFFF' }])
							},
							label: {
								color: '#0065B1',
								show: true,
								position: 'top'
							}
						}
					]
				};
				voucherDataStatistics().then(res => {
					if (res.data.code == '200') {
						option.xAxis[0].data = res.data.data.xAxisdata;
						option.series[0].data = res.data.data.seriesdata;
					}
					myChart.setOption(option);
				});

				let myChartA = echarts.init(document.getElementById('brokenLine'));
				let colors = ['#88E4CE', '#FFD79B', '#80B2D8', '#EBB7B7', '#CCBBF0', '#AED8FF'];
				let options = {
					color: colors,
					tooltip: {
						trigger: 'axis'
					},
					grid: {
						top: '31',
						left: '19',
						right: '26',
						bottom: '25',
						containLabel: true
					},
					xAxis: {
						axisLine: {
							lineStyle: {
								color: '#BFBFBF'
							}
						},
						type: 'category',
						boundaryGap: false,
						data: []
					},
					yAxis: {
						type: 'value',
						axisLine: {
							lineStyle: {
								color: '#BFBFBF'
							}
						}
					},
					series: []
				};
				myChartA.setOption(options);
				voucherDataContrast().then(res => {
					if (res.data.code == '200') {
						options.xAxis.data = res.data.data.xAxis;
						options.series = res.data.data.series.map(v => {
							v.stack = '';
							return v;
						});
					}
					this.$nextTick(() => {
						myChartA.setOption(options);
					});
				});
				this.$nextTick(() => {
					window.addEventListener('resize', function() {
						myChart.resize();
						myChartA.resize();
					});
				});
			});
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
